module.exports = "/dist/assets/images/small_checkmark.svg";